/** Runtime config served by the api at /config.json. Nothing here is secret and nothing is baked into the bundle. */
export interface RuntimeConfig {
  productName: string;
  supabaseUrl: string;
  supabasePublishableKey: string;
  mediaPublicBase: string;
}

let cached: RuntimeConfig | null = null;

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { credentials: 'same-origin' });
  if (!res.ok) throw new Error(`config.json ${res.status}`);
  cached = (await res.json()) as RuntimeConfig;
  return cached;
}

export function config(): RuntimeConfig {
  if (!cached) throw new Error('config not loaded');
  return cached;
}
